import type { ProductGranularity } from '@backmarket/http-api/src/api-specs-content/models/refined-products'

import type { Product } from '../../models/product'

/**
 * RefinedProduct cards can have 3 productGranularity value types:
 *
 * "parent":
 *   -> colour swatches
 *   -> no description
 *   -> "starting from" translation key above price.
 *
 * "variant"
 *  -> no colour swatches
 *  -> has a description
 *  -> should not have a "starting from" translation or colour swatches
 *
 * - "backbox"
 *  -> no "starting from" or colour swatches
 *  -> description has this format: "sub_title_elements • backbox_grade_label • special_offer_type"
 *     where special_offer_type can either be 0 or 7.
 *     If it's 7 add a translation key, if it's 0 don't add anything.
 */

export function colorSwatches(
  specifications: Product['specifications'] | undefined,
  productGranularity: ProductGranularity,
) {
  if (productGranularity !== 'parent' || !specifications) return []
  if (!('color' in specifications)) return []

  return specifications.color
}

export function withStartingFrom(productGranularity: ProductGranularity) {
  return productGranularity === 'parent'
}

export function extendedDescription(productGranularity: ProductGranularity) {
  return productGranularity === 'backbox' || productGranularity === 'variant'
}
